import React, { useState } from 'react';
import { DateRangePicker } from 'react-date-range';
import { de } from 'date-fns/locale';
import { useGetList } from 'react-admin';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import { Select, Button } from '@mui/material';
import {
  Dialog,
  MenuItem,
  FormControl,
  InputLabel,
  Stack,
} from '@mui/material';
import {
  addDays,
  addWeeks,
  endOfDay,
  startOfDay,
  startOfMonth,
  endOfMonth,
  addMonths,
  startOfWeek,
  endOfWeek,
  isSameDay,
  differenceInCalendarDays,
  differenceInDays,
} from 'date-fns';

export const CampaignDataFilters = ({
  selectionRange,
  setSelectionRange,
  adParameter,
  setAdParameter,
  selectedCompany,
  setSelectedCompany,
  setSelectionRangeType,
}) => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const companies = useGetList('companies');

  const handleSelect = (ranges) => {
    console.log('ranges', ranges);
    const diff = differenceInDays(
      ranges.selection.endDate,
      ranges.selection.startDate
    );

    if (diff > 6) {
      setSelectionRangeType('week');
    } else {
      setSelectionRangeType('day');
    }

    const selection = {
      startDate: startOfDay(ranges.selection.startDate),
      endDate: endOfDay(ranges.selection.endDate),
      key: 'selection',
    };

    setSelectionRange(selection);
  };

  const handleClickOpen = () => {
    setDialogOpen(true);
  };

  const handleClose = (value) => {
    setDialogOpen(false);
  };

  const handleAdParameterChange = (e) => {
    setAdParameter(e.target.value);
  };

  const handleCompanyChange = (e) => {
    setSelectedCompany(e.target.value);
  };

  function isSelected(range) {
    const definedRange = this.range();
    return (
      isSameDay(range.startDate, definedRange.startDate) &&
      isSameDay(range.endDate, definedRange.endDate)
    );
  }

  return (
    <Stack
      direction="row"
      spacing={2}
      sx={{
        justifyContent: 'flex-end',
        alignItems: 'center',
      }}
    >
      <FormControl sx={{ m: 1 }}>
        <InputLabel id="data-type-select-helper-label">Type</InputLabel>
        <Select
          labelId="data-type-label"
          id="data-type-select"
          value={adParameter}
          label={false}
          onChange={handleAdParameterChange}
          size={'small'}
        >
          <MenuItem value={'utm_source'}>Utm Source</MenuItem>
          <MenuItem value={'utm_campaign'}>Utm Campaign</MenuItem>
          <MenuItem value={'utm_content'}>Utm Content</MenuItem>
          <MenuItem value={'utm_medium'}>Utm Medium</MenuItem>
        </Select>
      </FormControl>
      <Button variant="contained" onClick={handleClickOpen} sx={{ width: 400 }}>
        Zeitraum
      </Button>

      <Dialog onClose={handleClose} open={dialogOpen}>
        <DateRangePicker
          locale={de}
          ranges={[selectionRange]}
          onChange={handleSelect}
          staticRanges={[
            {
              label: 'Heute',
              range: () => ({
                startDate: startOfDay(new Date()),
                endDate: endOfDay(new Date()),
              }),
              isSelected,
            },
            {
              label: 'Gestern',
              range: () => ({
                startDate: startOfDay(addDays(new Date(), -1)),
                endDate: endOfDay(addDays(new Date(), -1)),
              }),
              isSelected,
            },
            {
              label: 'Diese Woche',
              range: () => ({
                startDate: startOfWeek(new Date(), { weekStartsOn: 1 }),
                endDate: endOfWeek(new Date(), { weekStartsOn: 1 }),
              }),
              isSelected,
            },
            {
              label: 'Letzte Woche',
              range: () => ({
                startDate: startOfWeek(addWeeks(new Date(), -1), {
                  weekStartsOn: 1,
                }),
                endDate: endOfWeek(addWeeks(new Date(), -1), {
                  weekStartsOn: 1,
                }),
              }),
              isSelected,
            },
            {
              label: 'Dieser Monat',
              range: () => ({
                startDate: startOfMonth(new Date(), { weekStartsOn: 1 }),
                endDate: endOfMonth(new Date(), { weekStartsOn: 1 }),
              }),
              isSelected,
            },
            {
              label: 'Letzter Monat',
              range: () => ({
                startDate: startOfMonth(addMonths(new Date(), -1)),
                endDate: endOfMonth(addMonths(new Date(), -1)),
              }),
              isSelected,
            },
          ]}
        />
      </Dialog>
    </Stack>
  );
};
